module.exports = __webpack_public_path__ + "media/components/country-flag/static/bm-2c5ef58519df37389e876c41973b5f0f.svg";